<template>
  <div v-if="videos && videos.length" class="model-videos">
    <ModalsVideoSelectModal
      v-if="modalOpen"
      :title="modalTarget.name"
      :video-id="modalTarget.id"
      @close="closeModal"
    />
    <h2 class="text-h3-bold-up model-videos__header">Видеообзоры</h2>
    <ui-multiple-swiper
      :free-mode="isMobile"
      class="model-videos__slider"
      :space-between="spaceBetween"
    >
      <ui-multiple-swiper-slide
        v-for="(video, index) in videos"
        :key="`${index}_preview-video`"
      >
        <PageModelModelVideosPreviewVideo
          class="model-videos__slider-container"
          :video="video"
          @click="onVideoClick(video, false)"
        />
      </ui-multiple-swiper-slide>
    </ui-multiple-swiper>

    <slot name="pagination" />
    <ui-ui-button
      v-if="showButton"
      class="model-videos__slider-btn"
      type="neutral"
      @click="$emit('to-route', 'videos')"
    >
      Смотреть все видеообзоры
    </ui-ui-button>
  </div>
</template>

<script setup lang="ts">
import type { ResponseModelVideos, ModelVideo } from '~/interfaces/api';
import { useMediaQueryStore } from '~/stores/mediaQuery';

defineProps({
  videos: {
    type: Array as () => ResponseModelVideos,
    default: () => [],
  },
  changedPage: Boolean,
  showButton: {
    type: Boolean,
    default: true,
  },
});

defineEmits(['to-route']);
const modalOpen = ref<boolean>(false);
const modalTarget = ref<Partial<ModelVideo>>({});
const mediaStore = useMediaQueryStore();
const isMobile = computed(
  () =>
    mediaStore.isMobile || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const spaceBetween = computed(() =>
  mediaStore.isEs || mediaStore.isSm || mediaStore.isMd ? 12 : 20
);

function openModal() {
  modalOpen.value = true;
}

function closeModal() {
  modalOpen.value = false;
}

function onVideoClick(videoObj: ModelVideo, blockClick: Boolean) {
  if (!blockClick) {
    openModal();
    modalTarget.value = videoObj;
  }
}
</script>
<style lang="scss" src="./ModelVideosScss.scss" scoped></style>
